import { useRouteContext } from "@tanstack/react-router";

import { trackEvent } from "@/lib/tracking";

export const FIRST_SCHEDULE_INTRO_ORIGINS = [
  "fim_do_fluxo",
  "cartao_cadastrado",
  "home",
  "link_direto",
] as const;

export type FirstScheduleIntroOrigin = (typeof FIRST_SCHEDULE_INTRO_ORIGINS)[number];

export type SuccessScreenOrigin = Extract<
  FirstScheduleIntroOrigin,
  "fim_do_fluxo" | "cartao_cadastrado"
>;

interface UseFirstScheduleIntroDestinationParams {
  origin: SuccessScreenOrigin;
  flowId?: number;
}

type FirstScheduleIntroDestination =
  | { to: "/onboarding/first-schedule/intro"; search: { origem: SuccessScreenOrigin } }
  | { to: "/"; search?: undefined };

interface UseFirstScheduleIntroDestinationResult {
  destination: FirstScheduleIntroDestination;
  trackContinue: () => void;
}

export const useFirstScheduleIntroDestination = ({
  origin,
  flowId,
}: UseFirstScheduleIntroDestinationParams): UseFirstScheduleIntroDestinationResult => {
  const { user, flags } = useRouteContext({ from: "__root__" });

  const isIntroEnabled = flags["exibe-introducao-da-primeira-agenda"];

  const destination: FirstScheduleIntroDestination =
    isIntroEnabled && !user.possuiAgendaAtiva
      ? { to: "/onboarding/first-schedule/intro", search: { origem: origin } }
      : { to: "/" };

  const trackContinue = (): void => {
    trackEvent("Tela de Sucesso Continuar Clicado", {
      origem: origin,
      grupo: isIntroEnabled ? "introducao" : "controle",
      possuiAgendaAtiva: user.possuiAgendaAtiva,
      codFluxo: flowId,
    });
  };

  return { destination, trackContinue };
};
